import { defineStore } from 'pinia';
import { softswiss } from '../transport/softswiss';

export const useStoreSsMessages = defineStore('ssMessages', {
  actions: {
    /**
     * Function for sending message from contact page
     **/
    async sendMessage(contact: { email: string; content: string }): Promise<any> {
      const sendingResult = await softswiss().post({
        path: `/api/send_contact_message`,
        force: true,
        getErrors: true,
        payload: { contact },
      });

      return sendingResult;
    },
  },
});
